import React from 'react';
import { Popup, Cell, Button, Picker, Toast } from 'zarm';
import ReactEcharts from 'echarts-for-react';
// 检查对比内容的布局
import * as ExamCompareLayouts from './components';
import './index.less';

// 数据对比

class DataCompare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // visible: false,
      // direction: 'right',
    }
  }

  render() {
    const { visible, direction = 'right', onClose = () => { }, afterClose = () => { }, data = {} } = this.props;
    const { examName, list = [], layout } = data;
    // 检查项的布局组件
    const ExamCompareLayout = ExamCompareLayouts[layout];
    return <Popup
      visible={visible}
      onMaskClick={onClose}
      direction={direction}
      afterClose={afterClose}
    >
      <div className="popup-box-right">
        <div className="exam_name">
          <div className="icon" />
          {examName}
        </div>
        <div className="exam_content">
          {
            ExamCompareLayout && <ExamCompareLayout
              data={{ ...data, noEcharts: data.examCode === '85014' }}
            />
          }
        </div>
      </div>
    </Popup>
  }
}

export default DataCompare;
